module.exports = __webpack_public_path__ + "static/media/pencil_gray.bb4ce3e7.svg";